export type SectionKey =
  | 'pillars'
  | 'goals'
  | 'categories'
  | 'authors'
  | 'author-categories'
  | 'mentor-boards'
  | 'mentor-shorts'
  | 'homepage-shorts'
  | 'promotions'
  | 'daily-missions'
  | 'levels';

export interface SectionDefinition {
  key: SectionKey;
  title: string;
  description: string;
}

export const CONTENT_MANAGEMENT_PATH = '/content-management';

export const sectionGroups: { title: string; sections: SectionDefinition[] }[] = [
  {
    title: 'Structure',
    sections: [
      { key: 'pillars', title: 'Pillars', description: 'Content pillars and pillar expertises' },
      { key: 'goals', title: 'Goals', description: 'Goals users can pick' },
      { key: 'categories', title: 'Categories', description: 'Lesson categories' },
    ],
  },
  {
    title: 'Mentors',
    sections: [
      { key: 'authors', title: 'Mentors', description: 'Mentor profiles' },
      { key: 'author-categories', title: 'Mentor Categories', description: 'Groups of mentors' },
      { key: 'mentor-boards', title: 'Mentor Boards', description: 'Board of advisors paths' },
      { key: 'mentor-shorts', title: 'Shorts', description: 'Mentor short videos' },
      {
        key: 'homepage-shorts',
        title: 'Homepage Shorts',
        description: 'Ranked homepage short feeds per user level and access',
      },
    ],
  },
  {
    title: 'Engagement',
    sections: [
      { key: 'promotions', title: 'Promotions', description: 'In-app promotions' },
      { key: 'daily-missions', title: 'Daily Missions', description: 'Daily mission templates' },
      { key: 'levels', title: 'Levels', description: 'Level definitions' },
    ],
  },
];

export const allSections = sectionGroups.flatMap((group) => group.sections);

export const defaultSection = allSections[0];

export const getSectionPath = (key: SectionKey) => `${CONTENT_MANAGEMENT_PATH}/${key}`;
